import React from "react";

import logo1 from "../assets/OQ.png";
import logo2 from "../assets/ORREDO.png";
import logo3 from "../assets/Petro.png";
import logo4 from "../assets/vodafon.png";
import logo5 from "../assets/bankmuscat.png";
import logo6 from "../assets/MB.png";
import logo7 from "../assets/rasalhamra.png";
import logo8 from "../assets/school.png";
import logo9 from "../assets/tanmia.png";
import logo10 from "../assets/TIbian.png";
import logo11 from "../assets/Amouage.png";


const logos = [
    logo1, logo2, logo3, logo4, logo5,
    logo6, logo7, logo8, logo9, logo10,logo11
    
  ];
function LogoCarousel() {
  return (
    <>
      <div className="w-full flex flex-col items-center justify-center py-12 overflow-hidden">
        {/* Title */}
        <h2 className="text-3xl sm:text-4xl font-bebas text-center mb-8 text-gray-800 dark:text-black">
          Our Trusted Clients
        </h2>

        {/* Scrolling Logos */}
        <div className="mt-10 w-full inline-flex flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_96px,_black_calc(100%-96px),transparent_100%)]">
          <ul className="flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll">
            {logos.concat(logos).concat(logos).map((logo, index) => ( 
              <li key={index}>
                <img src={logo} alt={`Client ${index + 1}`} className="w-16 h-16 object-contain" />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}

export default LogoCarousel;
